var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommingsoon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1400px",
    height: "650px",
    viewBox: "0 0 1509 893",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-25.3%",
    y: "-25.3%",
    width: "150.6%",
    height: "150.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50.2%",
    y: "-50.2%",
    width: "200.3%",
    height: "200.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Full-HD-Copy",
    transform: "translate(-167, -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(317, 245)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F7F3ED",
    filter: "url(#filter-1)",
    cx: 296.5,
    cy: 296.5,
    r: 296.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#BAFFBD",
    filter: "url(#filter-2)",
    cx: 1059.5,
    cy: 329.5,
    r: 149.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Coming-Soon",
    fontFamily: "FONTSPRINGDEMO-ProximaNovaExtraboldRegular, FONTSPRING DEMO - Proxima Nova Extrabold",
    fontSize: 151.365132,
    fontWeight: 700,
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 167.343773,
    y: 353
  }, "Coming Soon")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommingsoon);
export default __webpack_public_path__ + "static/media/commingsoon.00b79ae94d12074de0fb34905a0be1e3.svg";
export { ForwardRef as ReactComponent };